import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  eligibilityCategorySchema,
  usStatesEnumSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const eligibilityCategoriesContract = c.router({
  listEligibilityCategories: {
    summary: "Get a list of eligibility categories",
    method: "GET",
    path: "/eligibility-categories",
    query: z.object({
      usState: usStatesEnumSchema.optional(),
      fplPercentage: z.number().optional(),
    }),
    responses: {
      [HTTPStatusCode.OK]: z.array(eligibilityCategorySchema),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
});
